// import format from "date-fns/format";
// import getDay from "date-fns/getDay";
// import parse from "date-fns/parse";
// import startOfWeek from "date-fns/startOfWeek";

import './stylecalendar.css'
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";


import React, { useState, useEffect } from "react";

import Cookies from "js-cookie";

import { Circles } from "react-loader-spinner";

import {
  Calendar,
  // dateFnsLocalizer,
  momentLocalizer,
} from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import moment from "moment";
import "moment-timezone"; // or 'moment-timezone/builds/moment-timezone-with-data[-datarange].js'. See their docs

import RecordsDashboard from "./RecordsDashboard";

// Set the IANA time zone you want to use
moment.tz.setDefault("Nairobi/Kenya");

// Setup the localizer by providing the moment Object
// to the correct localizer.
const localizer = momentLocalizer(moment); // or globalizeLocalizer



// let events = [

// ];

function RecordsCalender() {
   const [foundErr, setFoundErr] = useState(null);
  const [isLoading, setIsLoading] = useState(null);

  const [records, setRecords] = useState([]);

    const [loading, setLoading] = useState(true);
    const [profile, setProfile] = useState(null);

  const [downloadPeriod, setDownloadPeriod] = useState("full");

  const [customStartDate, setCustomStartDate] = useState(null);
  const [customEndDate, setCustomEndDate] = useState(new Date());

  const [newEvent, setNewEvent] = useState({
  title: "",
  start: null,
  end: null,
});



  const handleRefreshRecords = () => {
  fetchRecords();
};
  const productColors = {
  milk: "#3b82f6",     // blue
  coffee: "#ef4444",   // red
  'tea leaves': "#10b981",      // green
};

const eventStyleGetter = (event) => {
  return {
    style: {
      backgroundColor: event.color,
      borderRadius: "6px",
      color: "white",
      border: "none",
      padding: "2px",
    },
  };
};





const calendarEvents = records.map((record) => {
  const type = (record.producttype || "").toLowerCase();

  return {
    id: record.id,
    title: `${record.weight}kg ${record.producttype}`,
    start: moment(record.daterecorded).toDate(),
    end: moment(record.daterecorded).toDate(),
    allDay: true,
    color: productColors[type] || "#6b7280",
  };
});


  useEffect(() => {
    //fetch agents
    const fetchAll = () => {
      let adminCookie = Cookies.get("sessioniduser");
      if (adminCookie.length >= 1) {
        setIsLoading(true);

        setTimeout(() => {
          fetch("https://api.terraweb.africa/getRecords", {
            method: "post",
            headers: { "Content-Type": "application/JSON" },
            body: JSON.stringify({
              userid: adminCookie,
            }),
          })
            .then(function (response) {
              if (response.status === 400) {
                throw Error("Wrong credentials");
              }
              if (response === 500) {
                throw Error("Could not complete request because of an error");
              }

              return response.json();
            })
        .then((data) => {

  console.log("Calendar API:", data);

  if (data?.records) {
    setRecords(data.records);
  } else {
    setRecords([]);
  }

    // safety check (important)
    if (data?.profile) {
      setProfile(data.profile || {});
      // setRecords(data.records || []);
    } else {
      // fallback for unexpected response
      setProfile({});
      // setRecords([]);
    }
  setFoundErr(null);
  setIsLoading(false);
})
            .catch((err) => {
              // setFoundErr(err.message);
              setIsLoading(null);
              // setFlag(1);
            });
        }, 2000);
      } else {
        setIsLoading(null);
      }
    };

    fetchAll();
  }, []);







  const fetchRecords = () => {
    let adminCookie = Cookies.get("sessioniduser");
    if (adminCookie.length >= 1) {
      setIsLoading(true);

      setTimeout(() => {
        fetch("https://api.terraweb.africa/getRecords", {
          method: "post",
          headers: { "Content-Type": "application/JSON" },
          body: JSON.stringify({
            userid: adminCookie,
          }),
        })
          .then(function (response) {
            if (response.status === 400) {
              throw Error("Wrong credentials");
            }
            if (response === 500) {
              throw Error("Could not complete request because of an error");
            }

            return response.json();
          })
      .then((data) => {

  console.log("Calendar API:", data);

  if (data?.records) {
    setRecords(data.records);
  } else {
    setRecords([]);
  }

  
    // safety check (important)
    if (data?.profile) {
      setProfile(data.profile || {});
      // setRecords(data.records || []);
    } else {
      // fallback for unexpected response
      setProfile({});
      // setRecords([]);
    }

  setFoundErr(null);
  setIsLoading(false);
})
          .catch((err) => {
            // setFoundErr(err.message);
            setIsLoading(null);
            // setFlag(1);
          });
      }, 5000);
    } else {
      setIsLoading(null);
    }
  };

  //refresh after add records
  const refreshRecords = () => {
    fetchRecords();
    
  };

  const getCompanyInitials = (name = "") => {
  return name
    .split(" ")
    .map(w => w[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
};

// working download

// const handleDownloadTable = async () => {
//   const doc = new jsPDF();

//   const filteredRecords = getFilteredRecords();
//   const currentDate = new Date().toISOString().replace("T", " ").split(".")[0];

//   const companyName =
//     filteredRecords?.[0]?.companyname ||
//     records?.[0]?.companyname ||
//     "Terraweb";

//   const initials = getCompanyInitials(companyName);

//   const getBase64ImageFromUrl = async (url) => {
//     const res = await fetch(url);
//     const blob = await res.blob();

//     return new Promise((resolve) => {
//       const reader = new FileReader();
//       reader.onloadend = () => resolve(reader.result);
//       reader.readAsDataURL(blob);
//     });
//   };

//   const faviconBase64 = await getBase64ImageFromUrl("/img/LOGO-FAVCON.png");

//   // avatar based on gender, same helper you use in the dashboard header
//   const avatarUrl = getGenderAvatar(profile?.gender);
//   const avatarBase64 = await getBase64ImageFromUrl(avatarUrl);

//   // =========================
//   // HEADER — USER PROFILE (LEFT)
//   // =========================
//   const avatarSize = 16;
//   const avatarX = 14;
//   const avatarY = 5;

//   // circular clip for the avatar
//   doc.saveGraphicsState();
//   doc.setFillColor(255, 255, 255);
//   doc.circle(
//     avatarX + avatarSize / 2,
//     avatarY + avatarSize / 2,
//     avatarSize / 2,
//     "F"
//   );
//   doc.clip();
//   doc.addImage(avatarBase64, "JPEG", avatarX, avatarY, avatarSize, avatarSize);
//   doc.restoreGraphicsState();

//   // thin ring around the avatar for polish
//   doc.setDrawColor(252, 156, 28);
//   doc.setLineWidth(0.6);
//   doc.circle(
//     avatarX + avatarSize / 2,
//     avatarY + avatarSize / 2,
//     avatarSize / 2,
//     "S"
//   );

//   const textX = avatarX + avatarSize + 4;

//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(12);
//   doc.setTextColor(20, 20, 20);
//   doc.text(profile?.username || "User", textX, avatarY + 6);

//   doc.setFont("helvetica", "normal");
//   doc.setFontSize(9);
//   doc.setTextColor(100, 100, 100);
//   doc.text(profile?.company || companyName, textX, avatarY + 11);

//   const isActive = (profile?.status || "").toLowerCase() === "active";
//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(8);
//   doc.setTextColor(...(isActive ? [22, 101, 52] : [153, 27, 27]));
//   doc.text(isActive ? "● Active" : "⛔ Suspended", textX, avatarY + 15.5);

//   // =========================
//   // HEADER — COMPANY BADGE (RIGHT)
//   // =========================
//   const badgeX = 180;
//   const badgeY = 5;
//   const badgeSize = 16;

//   doc.setFillColor(252, 156, 28);
//   doc.roundedRect(badgeX, badgeY, badgeSize, badgeSize, 3, 3, "F");

//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(18);
//   doc.setTextColor(255, 255, 255);

//   const textWidth = doc.getTextWidth(initials);

//   doc.text(
//     initials,
//     badgeX + badgeSize / 2 - textWidth / 2,
//     badgeY + 11
//   );

//   doc.setTextColor(0, 0, 0);

//   // =========================
//   // META LINE
//   // =========================
//   doc.setFontSize(10);
//   doc.setFont("helvetica", "bold");
//   doc.setTextColor(0, 0, 0);
//   doc.text(`Company: ${companyName}`, 14, 30);
//   doc.text(`Generated: ${currentDate}`, 14, 36);

//   // subtle divider under the header block
//   doc.setDrawColor(230, 230, 230);
//   doc.setLineWidth(0.3);
//   doc.line(14, 40, 196, 40);

//   // =========================
//   // PRODUCTION KEY / LEGEND
//   // =========================
//   const productTotals = {};

//   filteredRecords.forEach((r) => {
//     const type = (r.producttype || "").toLowerCase();
//     const weight = Number(r.weight) || 0;
//     productTotals[type] = (productTotals[type] || 0) + weight;
//   });

//   const legendItems = [
//     { key: "milk", label: "Milk", color: [37, 99, 235] },
//     { key: "coffee", label: "Coffee", color: [239, 68, 68] },
//     { key: "tea leaves", label: "Tea Leaves", color: [34, 197, 94] },
//   ];

//   let legendX = 14;
//   const legendY = 47;

//   legendItems.forEach((item) => {
//     const total = productTotals[item.key] || 0;

//     doc.setFillColor(...item.color);
//     doc.roundedRect(legendX, legendY - 3.5, 4, 4, 1, 1, "F");

//     doc.setFont("helvetica", "normal");
//     doc.setFontSize(9);
//     doc.setTextColor(0, 0, 0);

//     const labelText = `${item.label}: ${total.toFixed(2)} kg`;
//     doc.text(labelText, legendX + 6, legendY);

//     legendX += doc.getTextWidth(labelText) + 14;
//   });

//   doc.setFont("helvetica", "normal");
//   doc.setFontSize(10);
//   doc.text(`Total Records: ${filteredRecords?.length || 0}`, 14, 55);

//   // =========================
//   // TABLE
//   // =========================

//   const tableColumn = [
//     "ID",
//     "Farmer ID",
//     "Product Type",
//     "Weight",
//     "Company",
//     "Full Name",
//     "Added by",
//     "Recorded Date",
//   ];

//   const tableRows = filteredRecords.map((r) => [
//     r.id,
//     r.farmerid,
//     r.producttype,
//     r.weight,
//     r.companyname,
//     r.fullname,
//     r.added_by || r.username || "system",
//     r.daterecorded,
//   ]);

//   autoTable(doc, {
//     head: [tableColumn],
//     body: tableRows,
//     startY: 62,
//     theme: "grid", // <-- draws borders around every cell instead of borderless "plain" theme
//     styles: {
//       fontSize: 9,
//       cellPadding: 3,
//       textColor: [40, 40, 40],
//       lineColor: [210, 210, 210], // soft gray borders, not harsh black
//       lineWidth: 0.15,
//     },
//     headStyles: {
//       fillColor: [252, 156, 28],
//       textColor: [0, 0, 0],
//       fontStyle: "bold",
//       lineColor: [230, 160, 60],
//       lineWidth: 0.2,
//     },
//     alternateRowStyles: {
//       fillColor: [250, 250, 250], // very light zebra striping, low opacity feel
//     },
//     margin: { top: 60, bottom: 25 },

//     // =========================
//     // ROW COLOR BY PRODUCT TYPE (now enabled, softened)
//     // =========================
//     didParseCell: function (data) {
//       if (data.section !== "body") return;

//       const productType = (data.row.raw[2] || "").toString().toLowerCase();

//       const rowColors = {
//         milk: [235, 243, 255],       // very light blue tint
//         coffee: [255, 240, 240],     // very light red tint
//         "tea leaves": [235, 250, 240], // very light green tint
//       };

//       const textColors = {
//         milk: [30, 64, 175],
//         coffee: [153, 27, 27],
//         "tea leaves": [22, 101, 52],
//       };

//       const bg = rowColors[productType];
//       if (bg) {
//         data.cell.styles.fillColor = bg;
//       }

//       if (data.column.index === 2 && textColors[productType]) {
//         data.cell.styles.textColor = textColors[productType];
//         data.cell.styles.fontStyle = "bold";
//       }
//     },

//     didDrawPage: function (data) {
//       const pageCount = doc.internal.getNumberOfPages();
//       const page = doc.internal.getCurrentPageInfo().pageNumber;

//       const pageHeight = doc.internal.pageSize.height;
//       const pageWidth = doc.internal.pageSize.width;

//       const iconSize = 8;

//       if (faviconBase64) {
//         doc.addImage(faviconBase64, "PNG", 14, pageHeight - 16, iconSize, iconSize);
//       }

//       doc.setFontSize(9);
//       doc.setFont("helvetica", "normal");
//       doc.setTextColor(0, 0, 0);

//       doc.text(
//         "Terraweb.africa — Empowering through technology",
//         25,
//         pageHeight - 10
//       );

//       doc.setFont("helvetica", "bold");
//       doc.text(
//         `Page ${page} of ${pageCount}`,
//         pageWidth - 15,
//         pageHeight - 10,
//         { align: "right" }
//       );
//     },
//   });

//   const safeDate = new Date()
//     .toISOString()
//     .replace(/T/, "_")
//     .replace(/:/g, "-")
//     .split(".")[0];

//   const fileName = `${companyName}_farmer_records_${safeDate}.pdf`;

//   doc.save(fileName);
// };

// new with profile

const getGenderAvatar = (gender) => {
  switch (gender) {
    case "female":
      return "/img/femaleavatar.jpg";
    case "male":
      return "/img/maleavatar.jpeg";
    default:
      return "/img/maleavatar.png";
  }
};

const handleDownloadTable = async () => {
  const doc = new jsPDF();

  const filteredRecords = getFilteredRecords();
  const currentDate = new Date().toISOString().replace("T", " ").split(".")[0];

  const companyName =
    filteredRecords?.[0]?.companyname ||
    records?.[0]?.companyname ||
    "Terraweb";

  const initials = getCompanyInitials(companyName);

  const getBase64ImageFromUrl = async (url) => {
    const res = await fetch(url);
    const blob = await res.blob();

    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  };

  const faviconBase64 = await getBase64ImageFromUrl("/img/LOGO-FAVCON.png");

  // // avatar based on gender, same helper you use in the dashboard header
  // const avatarUrl = getGenderAvatar(profile?.gender);
  // const avatarBase64 = await getBase64ImageFromUrl(avatarUrl);

  const getBase64FromImageElement = (url) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      resolve(canvas.toDataURL("image/png"));
    };
    img.onerror = (err) => reject(err);
    img.src = url;
  });

// =========================
// HEADER — USER PROFILE (LEFT)
// =========================
const avatarSize = 16;
const avatarX = 14;
const avatarY = 5;

let avatarBase64 = null;
try {
  const avatarUrl = getGenderAvatar(profile?.gender);
  avatarBase64 = await getBase64FromImageElement(avatarUrl);
} catch (err) {
  console.warn("Avatar failed to load, skipping image:", err);
}

if (avatarBase64) {
  try {
    doc.saveGraphicsState();
    doc.setFillColor(255, 255, 255);
    doc.circle(avatarX + avatarSize / 2, avatarY + avatarSize / 2, avatarSize / 2, "F");
    doc.clip();
    doc.addImage(avatarBase64, "PNG", avatarX, avatarY, avatarSize, avatarSize);
  } catch (err) {
    console.warn("Avatar draw failed:", err);
  } finally {
    doc.restoreGraphicsState(); // ALWAYS runs, even if addImage throws
  }

  doc.setDrawColor(252, 156, 28);
  doc.setLineWidth(0.6);
  doc.circle(avatarX + avatarSize / 2, avatarY + avatarSize / 2, avatarSize / 2, "S");
} else {
  // fallback: colored circle so the layout doesn't look broken without an image
  doc.setFillColor(200, 200, 200);
  doc.circle(avatarX + avatarSize / 2, avatarY + avatarSize / 2, avatarSize / 2, "F");
}

const textX = avatarX + avatarSize + 4;

doc.setFont("helvetica", "bold");
doc.setFontSize(12);
doc.setTextColor(20, 20, 20);
doc.text(profile?.fullname || "", textX, avatarY + 6);

doc.setFont("helvetica", "normal");
doc.setFontSize(9);
doc.setTextColor(100, 100, 100);
doc.text(profile?.email || "", textX, avatarY + 11);

const isActive = (profile?.status || "").toLowerCase() === "active";
doc.setFont("helvetica", "bold");
doc.setFontSize(8);
doc.setTextColor(...(isActive ? [22, 101, 52] : [153, 27, 27]));
doc.text(isActive ? "Active" : "", textX, avatarY + 15.5);

  // =========================
  // HEADER — COMPANY BADGE (RIGHT)
  // =========================
  const badgeX = 180;
  const badgeY = 5;
  const badgeSize = 16;

  doc.setFillColor(252, 156, 28);
  doc.roundedRect(badgeX, badgeY, badgeSize, badgeSize, 3, 3, "F");

  doc.setFont("helvetica", "bold");
  doc.setFontSize(18);
  doc.setTextColor(255, 255, 255);

  const textWidth = doc.getTextWidth(initials);

  doc.text(
    initials,
    badgeX + badgeSize / 2 - textWidth / 2,
    badgeY + 11
  );

  doc.setTextColor(0, 0, 0);

  // =========================
  // META LINE
  // =========================
  doc.setFontSize(10);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(0, 0, 0);
  doc.text(`Company: ${companyName}`, 14, 30);
  doc.text(`Generated: ${currentDate}`, 14, 36);

  // subtle divider under the header block
  doc.setDrawColor(230, 230, 230);
  doc.setLineWidth(0.3);
  doc.line(14, 40, 196, 40);

  // =========================
  // PRODUCTION KEY / LEGEND
  // =========================
  const productTotals = {};

  filteredRecords.forEach((r) => {
    const type = (r.producttype || "").toLowerCase();
    const weight = Number(r.weight) || 0;
    productTotals[type] = (productTotals[type] || 0) + weight;
  });

  const legendItems = [
    { key: "milk", label: "Milk", color: [37, 99, 235] },
    { key: "coffee", label: "Coffee", color: [239, 68, 68] },
    { key: "tea leaves", label: "Tea Leaves", color: [34, 197, 94] },
  ];

  let legendX = 14;
  const legendY = 47;

  legendItems.forEach((item) => {
    const total = productTotals[item.key] || 0;

    doc.setFillColor(...item.color);
    doc.roundedRect(legendX, legendY - 3.5, 4, 4, 1, 1, "F");

    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(0, 0, 0);

    const labelText = `${item.label}: ${total.toFixed(2)} kg`;
    doc.text(labelText, legendX + 6, legendY);

    legendX += doc.getTextWidth(labelText) + 14;
  });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`Total Records: ${filteredRecords?.length || 0}`, 14, 55);

  // =========================
  // TABLE
  // =========================

  const tableColumn = [
    "ID",
    "Farmer ID",
    "Product Type",
    "Weight",
    "Company",
    "Full Name",
    "Added by",
    "Recorded Date",
  ];

  const tableRows = filteredRecords.map((r) => [
    r.id,
    r.farmerid,
    r.producttype,
    r.weight,
    r.companyname,
    r.fullname,
    r.added_by || r.username || "system",
    r.daterecorded,
  ]);

  autoTable(doc, {
    head: [tableColumn],
    body: tableRows,
    startY: 62,
    theme: "grid", // <-- draws borders around every cell instead of borderless "plain" theme
    styles: {
      fontSize: 9,
      cellPadding: 3,
      textColor: [40, 40, 40],
      lineColor: [210, 210, 210], // soft gray borders, not harsh black
      lineWidth: 0.15,
    },
    headStyles: {
      fillColor: [252, 156, 28],
      textColor: [0, 0, 0],
      fontStyle: "bold",
      lineColor: [230, 160, 60],
      lineWidth: 0.2,
    },
    alternateRowStyles: {
      fillColor: [250, 250, 250], // very light zebra striping, low opacity feel
    },
    margin: { top: 60, bottom: 25 },

    // =========================
    // ROW COLOR BY PRODUCT TYPE (now enabled, softened)
    // =========================
    didParseCell: function (data) {
      if (data.section !== "body") return;

      const productType = (data.row.raw[2] || "").toString().toLowerCase();

      const rowColors = {
        milk: [235, 243, 255],       // very light blue tint
        coffee: [255, 240, 240],     // very light red tint
        "tea leaves": [235, 250, 240], // very light green tint
      };

      const textColors = {
        milk: [30, 64, 175],
        coffee: [153, 27, 27],
        "tea leaves": [22, 101, 52],
      };

      const bg = rowColors[productType];
      if (bg) {
        data.cell.styles.fillColor = bg;
      }

      if (data.column.index === 2 && textColors[productType]) {
        data.cell.styles.textColor = textColors[productType];
        data.cell.styles.fontStyle = "bold";
      }
    },

    didDrawPage: function (data) {
      const pageCount = doc.internal.getNumberOfPages();
      const page = doc.internal.getCurrentPageInfo().pageNumber;

      const pageHeight = doc.internal.pageSize.height;
      const pageWidth = doc.internal.pageSize.width;

      const iconSize = 8;

      if (faviconBase64) {
        doc.addImage(faviconBase64, "PNG", 14, pageHeight - 16, iconSize, iconSize);
      }

      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");
      doc.setTextColor(0, 0, 0);

      doc.text(
        "Terraweb.africa — Empowering through technology",
        25,
        pageHeight - 10
      );

      doc.setFont("helvetica", "bold");
      doc.text(
        `Page ${page} of ${pageCount}`,
        pageWidth - 15,
        pageHeight - 10,
        { align: "right" }
      );
    },
  });

  const safeDate = new Date()
    .toISOString()
    .replace(/T/, "_")
    .replace(/:/g, "-")
    .split(".")[0];

  const fileName = `${companyName}_farmer_records_${safeDate}.pdf`;

  doc.save(fileName);
};

  const getFilteredRecords = () => {
  const now = new Date();

  if (downloadPeriod === "full") return records;

  if (downloadPeriod === "month") {
    return records.filter((r) => {
      const d = new Date(r.daterecorded);
      return (
        d.getMonth() === now.getMonth() &&
        d.getFullYear() === now.getFullYear()
      );
    });
  }

  if (downloadPeriod === "custom") {
    if (!customStartDate || !customEndDate) return [];

    return records.filter((r) => {
      const d = new Date(r.daterecorded);
      // return (
      //   d >= customStartDate &&
      //   d <= new Date(customEndDate.setHours(23, 59, 59, 999))
      // );
      const endDate = new Date(customEndDate);
endDate.setHours(23, 59, 59, 999);

return (
  d >= customStartDate &&
  d <= endDate
);
    });
  }

  return records;
};

// const monthlyTotals = records.reduce((acc, r) => {
//   const month = new Date(r.daterecorded).getMonth();
//   acc[month] = (acc[month] || 0) + parseFloat(r.weight || 0);
//   return acc;
// }, {});

const monthlyTotals = records.reduce((acc, r) => {
  const date = new Date(r.daterecorded);
  const key = `${date.getFullYear()}-${date.getMonth()}`; // e.g. "2026-0"
  acc[key] = (acc[key] || 0) + parseFloat(r.weight || 0);
  return acc;
}, {});


  return (
    <div className="Apppp bg-white pa4 mt6 w-80-l center">
      {/* PAGE HEADER */}


      {/* FILTER + ACTIONS SECTION */}
      <div className="bg-near-white br4 shadow-2 pa4 mb1">
        
  
        {/* stats section */}

        <RecordsDashboard />


 {/* LOADER */}
            {isLoading ? (
              <div className="mt3">
                <Circles
                  type="Oval"
                  color="#1b1b1b"
                  height={40}
                  width={40}
                />
              </div>
            ) : null}

            {/* ERROR */}
            {foundErr ? (
              <label className="db red mt3 fw6">
                {foundErr}
              </label>
            ) : null}

      </div>




{/* <div className="flex flex-wrap-ns justify-center mb0 overflow-x-auto">
  {Object.entries(monthlyTotals).map(([month, total]) => (
    <div
      key={month}
      className="bg-white shadow-1 br3 pa3 ma2 tc flex-shrink-0"
      style={{ minWidth: "140px" }}
    >
      <p><b>Total Monthly Records</b></p>
      <div className="f6 gray">
        {moment().month(month).format("MMMM")}
      </div>
      <div className="f3 fw6 green">
        {Number(total).toFixed(2)} kg
      </div>
    </div>
  ))}
</div> */}

<div className="flex flex-wrap-ns justify-center mb0 overflow-x-auto">
  {Object.entries(monthlyTotals).map(([key, total]) => {
    const [year, monthIndex] = key.split("-");
    return (
      <div
        key={key}
        className="bg-white shadow-1 br3 pa3 ma2 tc flex-shrink-0"
        style={{ minWidth: "140px" }}
      >
        <p><b>Total Monthly Records</b></p>
        <div className="f6 gray">
          {moment().month(Number(monthIndex)).format("MMMM")} {year}
        </div>
        <div className="f3 fw6 green">
          {Number(total).toFixed(2)} kg
        </div>
      </div>
    );
  })}
</div>

<div className="overflow-x-auto">
  <div className="mw-none" style={{ minWidth: "950px" }}>

  
      <Calendar
  localizer={localizer}
  // events={events}
    events={calendarEvents}
  startAccessor="start"
  endAccessor="end"
  eventPropGetter={eventStyleGetter}
  style={{
    height: 550,
    marginTop: "3px",
    backgroundColor: "white",
    padding: "10px",
    borderRadius: "12px",
  }}
/>
</div>
</div>
      <div className="bg-near-white br4 shadow-2 pa4 mb5">


 {/* TOP GRID */}
       
  
        {/* DOWNLOAD SECTION */}
        <div className="flex flex-column flex-row-l items-start items-end-l justify-between">

          {/* LEFT SIDE */}
          <div className="w-100 w-70-l">

            <h3 className="f4 fw6 near-black ma0 mb3">
              Download Farmer Records
            </h3>

            <div className="flex flex-column flex-row-l flex-wrap items-start">

              {/* PERIOD SELECT */}
              <div className="mr3 mb3">
                <label className="db mb2 fw6 gray f6">
                  Export Period
                </label>

                <select
                  className="
              pa2
              br3
              ba
              b--light-silver
              bg-white
              dark-gray
              outline-0
              w5
            "
                  value={downloadPeriod}
                  onChange={(e) =>
                    setDownloadPeriod(e.target.value)
                  }
                >

                  <option value="full">
                    Full Records
                  </option>

                  <option value="month">
  Total Monthly Records
</option>

                  <option value="custom">
                    Custom Range
                  </option>
                </select>
              </div>

              {/* CUSTOM DATES */}
              {downloadPeriod === "custom" && (
                <>
                  {/* FROM */}
                  <div className="mr3 mb3">
                    <label className="db mb2 fw6 gray f6">
                      From
                    </label>

                    <DatePicker
                      selected={customStartDate}
                      onChange={(date) =>
                        setCustomStartDate(date)
                      }
                      placeholderText="Start Date"
                      className="
                  pa2
                  br3
                  ba
                  b--light-silver
                  bg-white
                  dark-gray
                  outline-0
                  w5
                "
                    />
                  </div>

                  {/* TO */}
                  <div className="mr3 mb3">
                    <label className="db mb2 fw6 gray f6">
                      To
                    </label>

                    <DatePicker
                      selected={customEndDate}
                      onChange={(date) =>
                        setCustomEndDate(date)
                      }
                      placeholderText="End Date"
                      className="
                  pa2
                  br3
                  ba
                  b--light-silver
                  bg-white
                  dark-gray
                  outline-0
                  w5
                "
                    />
                  </div>
                </>
              )}
            </div>
          </div>

          {/* DOWNLOAD BUTTON */}
          <div className="mt4 mt0-l">
            <button
              onClick={handleDownloadTable}
              className="
          pointer
          bn
          br-pill
          white
          bg-dark-green
          hover-bg-green
          pa3
          ph4
          fw6
          shadow-1
          dim
          transition
        "
            >
              ⬇ Download PDF
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RecordsCalender;

function generateMockRecordsMultiMonth(monthsBack = 14) {
  const types = ["milk", "coffee", "tea leaves"];
  const mock = [];
  let id = 2000;

  for (let m = monthsBack; m >= 0; m--) {
    const date = new Date();
    date.setMonth(date.getMonth() - m);
    date.setDate(Math.floor(Math.random() * 27) + 1); // random day in month

    // a few records per month so totals aren't just one entry
    for (let j = 0; j < 3; j++) {
      const type = types[Math.floor(Math.random() * types.length)];
      mock.push({
        id: id++,
        farmerid: "GA012",
        producttype: type,
        weight: String(Math.floor(Math.random() * 50) + 5),
        companyname: "Gatamura Dairy",
        fullname: "Vin User",
        daterecorded: date.toISOString(),
        status: "null",
        approved_status: Math.random() > 0.2 ? "approved" : "pending",
        date_approved: date.toISOString(),
        edited_by: "Victor_e4HOsh",
        date_modified: date.toISOString(),
        username: "Vinuser",
        gender: "female",
        company: "Gatamura Dairy",
      });
    }
  }

  return mock;
}